/**
 * Return path selection from SignalK Explorer to dashboard widget editor.
 */
const STORAGE_KEY = 'boatwise.signalkPickerReturn';
const MAX_AGE_MS = 15 * 60 * 1000;

export function writeSignalkPickerReturn({ dashboardId, widgetId, path, sectionId }) {
  if (!dashboardId || !path) return;
  sessionStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      dashboardId: String(dashboardId),
      widgetId: widgetId != null ? String(widgetId) : 'draft',
      sectionId: sectionId != null ? String(sectionId) : '',
      path: String(path),
      ts: Date.now(),
    })
  );
}

export function readSignalkPickerReturn(dashboardId) {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || String(data.dashboardId) !== String(dashboardId)) return null;
    if (!data.path || Date.now() - (data.ts || 0) > MAX_AGE_MS) {
      sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }
    sessionStorage.removeItem(STORAGE_KEY);
    return data;
  } catch {
    sessionStorage.removeItem(STORAGE_KEY);
    return null;
  }
}

export function buildExplorerPickerHref({
  vesselId,
  dashboardId,
  widgetId,
  sectionId,
  returnTo,
}) {
  if (!vesselId || !dashboardId) return null;
  const params = new URLSearchParams({
    dashboardId: String(dashboardId),
    picker: '1',
    widgetId: widgetId != null ? String(widgetId) : 'draft',
  });
  if (sectionId) params.set('sectionId', String(sectionId));
  if (returnTo) params.set('returnTo', returnTo);
  return `/vessels/${vesselId}/signalk/explore?${params.toString()}`;
}

/** Merge a picked path into widget editor state. */
export function applyPickedPathToWidget(widget, { path, sectionId }) {
  const section = sectionId != null ? parseInt(sectionId, 10) : widget?.sectionId;
  return {
    ...widget,
    sectionId: section || widget?.sectionId,
    dataSource: path,
    data_path: path,
    dataPath: path,
    config: { ...(widget?.config || {}), dataPath: path },
  };
}

export function resumeWidgetEditorFromPicker(dashboardId, sections) {
  const picked = readSignalkPickerReturn(dashboardId);
  if (!picked?.path) return null;

  const path = picked.path;
  const sectionId = picked.sectionId ? parseInt(picked.sectionId, 10) : null;

  if (picked.widgetId && picked.widgetId !== 'draft') {
    const wid = parseInt(picked.widgetId, 10);
    for (const section of sections || []) {
      const w = section.widgets?.find((x) => Number(x.id) === wid);
      if (w) {
        return applyPickedPathToWidget(w, { path, sectionId: section.id });
      }
    }
    return { error: 'Could not find widget to update' };
  }

  return applyPickedPathToWidget(
    {
      sectionId: sectionId || sections?.[0]?.id,
      type: 'digital',
      widget_type: 'digital',
    },
    { path, sectionId: sectionId || sections?.[0]?.id }
  );
}
